import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=68ba11f7&scoped=true&"
import script from "./VModal.vue?vue&type=script&lang=js&"
export * from "./VModal.vue?vue&type=script&lang=js&"
import style0 from "./VModal.vue?vue&type=style&index=0&id=68ba11f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba11f7",
  null
  
)

export default component.exports